import React, { useEffect } from 'react';
import './SetLanguage.scss';
import { Button } from '../../../../Components/StyledComponents';

const SetLanguage = ({ languageInfo, patchLanguage }) => {
    const [en, setEn] = React.useState(false);
    const [zh, setZh] = React.useState(false);
    const [ja, setJa] = React.useState(false);

    useEffect(()=>{
        setEn(languageInfo.en);
        setZh(languageInfo['zh-Hans']);
        setJa(languageInfo.ja);
    }, []);

    const patch = () => {
        patchLanguage({ko: true, en: en, 'zh-Hans': zh, ja: ja})
    }

    return (
        <div className='set-delivery-area'>
            <div className='row' style={{justifyContent:'space-between'}}>
                <div className='row'>
                        <p className='modal-title'>지원 언어 선택</p>
                    </div>
                <div className='row'>
                    <button className={`${en ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight: 16, width: 100 }} onClick={() => setEn(!en)}>
                        <div className='row' style={{ justifyContent: 'center' }}>
                            영어
                        </div>
                    </button>
                    <button className={`${zh ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight: 16, width: 100 }} onClick={() => setZh(!zh)}>
                        <div className='row' style={{ justifyContent: 'center' }}>
                            중국어
                        </div>
                    </button>
                    <button className={`${ja ? 'selected-btn' : 'unselected-btn'}`} style={{ width: 100 }} onClick={() => setJa(!ja)}>
                        <div className='row' style={{ justifyContent: 'center' }}>
                            일본어
                        </div>
                    </button>
                </div>
            </div>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default SetLanguage;